import useSWR from 'swr';
import { useToken } from '../auth/token';
import API from '../../../utils/api';
import React from 'react';

export function useTradePosition() {
  let list: any = [];
  const [mitLengtht, setMitLengtht] = React.useState(0);
  const { data: token } = useToken();
  const KEYURL = '/trade/status';

  const {
    data = [],
    mutate,
    isLoading,
  } = useSWR(
    token ? KEYURL : null,
    async () => {
      const response = await API.get(KEYURL, token + '', {}, false);
      return response?.result?.result;
    },
    { revalidateOnFocus: true, refreshInterval: 60 * 1000 }
  );

  data?.open_positions?.map((item: any) => {
    if (item?.tpsl) {
      const TPSL = item?.tpsl?.[0];

      if (TPSL) {
        if (+TPSL?.tp != 0) {
          list = [
            {
              ...item,
              posid: item?.id,
              posprice: item?.price,
              poslongshort: item?.long_short,
              status: 1,
              limit_market: 'L',
              long_short: item?.long_short == 'L' ? 'S' : 'L',
              order_price: +TPSL?.tp,
              type: 'TP',
              tpsltype: TPSL?.tp + ' ' + TPSL?.tptype,
              tpsl: TPSL,
            },
            ...list,
          ];
        }
        if (+TPSL?.sl != 0) {
          list = [
            {
              ...item,
              posid: item?.id,
              posprice: item?.price,
              poslongshort: item?.long_short,
              status: 1,
              limit_market: 'L',
              long_short: item?.long_short == 'L' ? 'S' : 'L',
              order_price: +TPSL?.sl,
              type: 'SL',
              tpsltype: TPSL?.sl + ' ' + TPSL?.sltype,
              tpsl: TPSL,
            },
            ...list,
          ];
        }
      }
    }
  });

  // console.log("mitLengtht", mitLengtht);

  return {
    data: data?.open_positions,
    orderlist: data?.order,
    spot: data?.spot,
    futures: data?.futures,
    global: data?.global,
    tpslList: list,
    mutate,
    mitLengtht: mitLengtht,
    isLoading: isLoading,
    setMitLengtht: (value: number) => {
      setMitLengtht(value);
    },
  };
}
